/**
 * Default values for payment notifications
 * These constants are shared with the server-side defaults
 */

/** Default email subject for payment notifications */
export const DEFAULT_NOTIFICATION_SUBJECT = `Pripomienka platby - faktúra {{INVOICENO}} - splatnosť {{DUEDATE}}`;

/** Default email text for payment notifications */
export const DEFAULT_NOTIFICATION_TEXT = `Vážený nájomca,

pripomíname Vám, že vaša úhrada vo výške {{VALUE}} spojená s prenájmom {{UNIT}} je splatná dňa {{DUEDATE}}.

Detail úhrady: 
{{INVOICEDESC}}

Úhradu prosím vykonajte na účet prenajímateľa {{BANKACCOUNT}}.
Názov účtu: {{BANKACCOUNTNAME}}
Pri platbe uveďte variabilný symbol: {{INVOICEREF}}

Pre pohodlné zaplatenie môžete použiť QR kód:
{{QRCODE}}

S pozdravom,
Váš prenajímateľ`;

/** Default email subject for payment confirmation */
export const DEFAULT_PAYMENT_CONFIRMATION_SUBJECT = `Potvrdenie prijatia platby - faktúra {{INVOICENO}}`;

/** Default email text for payment confirmation */
export const DEFAULT_PAYMENT_CONFIRMATION_TEXT = `Vážený nájomca,

potvrdujeme, že sme prijali vašu platbu vo výške {{VALUE}} € za faktúru {{INVOICENO}}.

Detail faktúry:
{{INVOICEDESC}}

Ďakujeme za úhradu.

S pozdravom,
Váš prenajímateľ`;

/** Default email subject for invoice information emails */
export const DEFAULT_INVOICE_INFORMATION_SUBJECT = `Informácie k faktúre {{INVOICENO}}`;

/** Default email text for invoice information emails */
export const DEFAULT_INVOICE_INFORMATION_TEXT = `Vážený nájomca,

zasielame Vám informácie k faktúre {{INVOICENO}} vo výške {{VALUE}}.

Splatnosť faktúry je {{DUEDATE}}.

Detail faktúry:
{{INVOICEDESC}}

Úhradu prosím vykonajte na účet prenajímateľa {{BANKACCOUNT}}.
Názov účtu: {{BANKACCOUNTNAME}}
Pri platbe uveďte variabilný symbol: {{INVOICEREF}}

S pozdravom,
Váš prenajímateľ`;
